<template>
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #s/n
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Patient Name
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        OPD/IPD
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Phone Contact
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Visit Date
      </th>
      <!-- <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Gender
                </th> -->

      <th class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.receipt_id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.patient_names }}</h6>
              <p class="text-xs text-secondary mb-0">
                {{ user.patient_emails == null ? "--" : user.patient_emails }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p class="text-xs font-weight-bold mb-0">
            OPD/{{ user.opd == null ? "--" : user.opd }}
          </p>
          <p class="text-xs text-secondary mb-0">
            IPD/{{ user.ipd == null ? "--" : user.ipd }}
          </p>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">{{
            user.patient_phones == null ? "---" : user.patient_phones
          }}</soft-badge>
        </td>
        <td class="align-middle text-center text-sm">
          <!-- {{ user.created_at }} -->
          <p>{{ formatDateTime1(user.receipt_date) }}</p>
        </td>
        <!-- <td class="align-middle text-center">
                    <span class="text-secondary text-xs font-weight-bold">{{
                      user.gender == null
                        ? "--"
                        : user.gender == 1
                        ? "Male"
                        : user.gender == 2
                        ? "Female"
                        : "Other"
                    }}</span>
                  </td> -->
        <td class="align-middle">
          <button
            @click="showReceipt(user.receipt_id)"
            style="
              border: 1px solid black;
              padding: 4px;
              color: green;
              font-weight: bold;
            "
            data-toggle="tooltip"
            data-original-title="Edit user"
          >
            Show Receipt
          </button>
        </td>
      </tr>
    </template>
  </BaseLayout>
  <ReceiptModal
    v-if="showIssuePrescriptionModal"
    @close-receipt-modal="closeResMod"
    :receiptID="current_receipt"
  />
</template>

<script>
// import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
import ReceiptModal from "./receipt_modal.vue";
import BaseLayout from "../../Patients/components/table_page_layout.vue";
import formatDateTime from "../../../timezone/utc_local_time";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      current_receipt: "",
      // visit_id: this.$route.params.storeLocation,
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "getReceiptsSearch",
      mainUrl: "get_all_gp_receipts_queue",
      showIssuePrescriptionModal: false,
    };
  },
  components: {
    BaseLayout,
    ReceiptModal,

    // Search
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    showReceipt(id) {
      this.current_receipt = id;
      this.showIssuePrescriptionModal = true;
    },
    closeResMod() {
      this.current_receipt = "";
      this.showIssuePrescriptionModal = false;
    },

    formatDateTime1(datetime) {
      return formatDateTime(datetime);
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
